const BlurEffect= () => {
  return (
    <div className="w-60 h-60 absolute right-0 top-0 bg-[#7947df] blur-[180px] rounded-full"></div>
  );
};

export default BlurEffect;
